import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';

import './FloatingActions.styles.scss';
import './FloatingActions.styles.responsive.scss';

export type FloatingActionsProps = {
  className?: string;
  message?: string;
  submitTxt?: string;
  cancelTxt?: string;
  disabled?: boolean;
  hideSubmit?: boolean;
  isVisible?: boolean;
  position?: 'fixed' | 'absolute';
  onCancel?: () => void;
  onSubmit?: () => void;
};

const FloatingActions: React.FC<FloatingActionsProps> = (props) => {
  const {
    children,
    className,
    message,
    submitTxt,
    cancelTxt,
    disabled = false,
    hideSubmit = false,
    isVisible = true,
    position = 'fixed',
    onCancel,
    onSubmit,
  } = props;

  const { t } = useTranslation();

  const classes = classNames(
    'floating-actions',
    `floating-actions--${position}`,
    { 'floating-actions--visible': isVisible },
    className,
  );

  return (
    <div className={classes} aria-hidden={!isVisible}>
      <div className="floating-actions__bar">
        {message && <div className="floating-actions__message">{message}</div>}

        <div className="floating-actions__buttons">
          {onCancel && (
            <Button variant="link" onClick={onCancel}>
              {cancelTxt ?? t('cancel')}
            </Button>
          )}

          {children}

          {!hideSubmit && (
            <Button
              type={onSubmit ? 'button' : 'submit'}
              disabled={disabled}
              {...(onSubmit && { onClick: onSubmit })}
            >
              {submitTxt ?? t('saveChanges')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FloatingActions;
